/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Template } from './template';


export interface Submission { 
    creationDate?: string;
    destinationUser?: string;
    id?: string;
    schema?: string;
    status?: string;
    submissionDateTime?: string;
    template?: Template;
}
